import type { IconProps } from "@/types/icon";

const DashIcon = ({ width = 12, height = 2, fill = "#F2F2F2", ...remainingProps }: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12 2"
            fill="none"
            {...remainingProps}
        >
            <path
                d="M1.49902 1H10.499"
                stroke={fill}
                strokeWidth="2.0025"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default DashIcon;
